import React from 'react';
import { useNavigate } from 'react-router-dom';

// Import custom TFS icons
import workOrdersIcon from '@/assets/app-icons/work_orders.png';
import clientCommunicationsIcon from '@/assets/app-icons/client_communications.png';
import calendarIcon from '@/assets/app-icons/calendar.png';
import inspectionsIcon from '@/assets/app-icons/inspections.png';
import preventiveMaintenanceIcon from '@/assets/app-icons/preventive_maintenance.png';
import buildingIntelligenceIcon from '@/assets/app-icons/building_intelligence.png';
import propertyEvaluationsIcon from '@/assets/app-icons/property_evaluations.png';
import incidentReportingIcon from '@/assets/app-icons/incident_reporting.png';
import trainingIcon from '@/assets/app-icons/training.png';
import vehicleInspectionsIcon from '@/assets/app-icons/vehicle_inspections.png';
import inventoryIcon from '@/assets/app-icons/inventory.png';
import fieldAdminIcon from '@/assets/app-icons/field_admin.png';

const AppLauncher = () => {
  const navigate = useNavigate();

  const apps = [
    // Row 1 - High Priority
    {
      id: 'work-orders',
      name: 'Work Orders',
      iconSrc: workOrdersIcon,
      path: '/admin/work-orders',
      description: 'Work order management'
    },
    {
      id: 'client-communications',
      name: 'Client Communications',
      iconSrc: clientCommunicationsIcon,
      path: '/admin/feedback',
      description: 'Client communications and feedback'
    },
    {
      id: 'calendar',
      name: 'Calendar',
      iconSrc: calendarIcon,
      path: '/admin/calendar',
      description: 'Schedule and calendar management'
    },
    // Row 2
    {
      id: 'inspections',
      name: 'Inspections',
      iconSrc: inspectionsIcon,
      path: '/admin/cleaning-inspections',
      description: 'Property inspections'
    },
    {
      id: 'preventive-maintenance',
      name: 'Preventive Maintenance',
      iconSrc: preventiveMaintenanceIcon,
      path: '/admin/bank-pm',
      description: 'Preventive maintenance programs'
    },
    {
      id: 'building-intelligence',
      name: 'Building Intelligence',
      iconSrc: buildingIntelligenceIcon,
      path: '/admin/building-intelligence',
      description: 'Facility intelligence data'
    },
    // Row 3
    {
      id: 'property-evaluations',
      name: 'Property Evaluations',
      iconSrc: propertyEvaluationsIcon,
      path: '/admin/evaluations',
      description: 'Property assessments'
    },
    {
      id: 'incident-reporting',
      name: 'Incident Reporting',
      iconSrc: incidentReportingIcon,
      path: '/admin/incident-reports',
      description: 'Incident reports and tracking'
    },
    {
      id: 'training',
      name: 'Training',
      iconSrc: trainingIcon,
      path: '/admin/training',
      description: 'Training programs and resources'
    },
    // Row 4
    {
      id: 'vehicle-inspections',
      name: 'Vehicle Inspections',
      iconSrc: vehicleInspectionsIcon,
      path: '/admin/inspections',
      description: 'Vehicle inspections'
    },
    {
      id: 'inventory',
      name: 'Inventory',
      iconSrc: inventoryIcon,
      path: '/admin/inventory',
      description: 'Inventory management'
    },
    {
      id: 'field-admin',
      name: 'Field Admin',
      iconSrc: fieldAdminIcon,
      path: '/admin/field-admin',
      description: 'Field administration tools'
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Application Launcher</h2>
        <p className="text-gray-600 mt-1">Select an app to manage submissions and data</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {apps.map((app) => {
          return (
            <button
              key={app.id}
              onClick={() => navigate(app.path)}
              className="group relative bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-200 p-6 text-left border border-gray-200 hover:border-transparent"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100 opacity-0 group-hover:opacity-100 rounded-lg transition-opacity duration-200"></div>
              
              <div className="relative inline-flex items-center justify-center w-20 h-20 mb-4">
                <img 
                  src={app.iconSrc} 
                  alt={app.name}
                  className="w-full h-full object-contain"
                />
              </div>
              
              <h3 className="relative text-lg font-semibold text-gray-800 mb-2 group-hover:text-gray-900">
                {app.name}
              </h3>
              
              <p className="relative text-sm text-gray-600 group-hover:text-gray-700">
                {app.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AppLauncher;
